export default __webpack_public_path__ + "static/media/eye.a835fb9b.png";